import type { TablerIcon } from "@tabler/icons-react";
import { IconEye, IconPencil } from "../../icons";

// Reading and writing are the two things this page is for, and the engine's third mode — suggesting, which records
// every edit as a tracked change — needs the review module @docx-editor.dev/pro sells, so it is not offered.
export const MODES = [
  { value: "view", label: "View", Icon: IconEye },
  { value: "edit", label: "Edit", Icon: IconPencil },
] as const satisfies readonly Mode[];

export type ModeId = typeof MODES[number]["value"];

// Opened to be read: most documents somebody drops on a page are ones they were sent, and a caret in a letter they
// only meant to read is a keystroke away from changing it.
export const DEFAULT_MODE: ModeId = "view";

export function isMode(value: unknown): value is ModeId {
  return MODES.some((mode) => mode.value === value);
}

interface Mode {
  value: string;
  label: string;
  Icon: TablerIcon;
}
